export const upgradeConstants = {
    USER_UPGRADE_SUCCESS: "USER_UPGRADE_SUCCESS",
    USER_UPGRADE_VERIFICATION_SUCCESS: "USER_UPGRADE_VERIFICATION_SUCCESS",
    USER_UPGRADE_FAILURE: "USER_UPGRADE_FAILURE",
    USER_UPGRADE_VERIFICATION_FAILURE: "USER_UPGRADE_VERIFICATION_FAILURE",
  };
  